/**
 * ** Grupo Posadas**
 *
 * @exports partnership_10012
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    const hostname = window.location.hostname;
    const dataLayer = window.dataLayer;
    // Posadas Group (special case) : Check that the hotel belongs to the brand's La Colección
    partnership.isPosadasLaColeccion = function isPosadasLaColeccion() {
        return !!hostname.match(/lacoleccionresorts/);
    };
    /**
       * @memberOf module:partnership_10012
       */
    partnership.getId = function getId() {
        return '10012';
    };
    /**
       * @memberOf module:partnership_10012
       */
    partnership.check = function check() {
        // Check if we are in the homepage of Grupo Posadas
        const hostnameRegex = /fiesta|onehoteles|gammahoteles|liveaqua|explorean|lacoleccionresorts|ioh-hoteles/;
        return hostname.match(hostnameRegex) && !hostname.match(/reservations/);
    };
    /**
       * @memberOf module:partnership_10012
       */
    partnership.getSiteId = function getSiteId() {
        // Get the hotel id from the dataLayer
        const hotelId = !partnership.isPosadasLaColeccion() ? thn.objectGet(dataLayer, 'id') : thn.objectGet(dataLayer, 'name');
        const result = {
            externalId: hotelId?.trim() || '',
        };
        return result;
    };
    return partnership;
}

export { factory };
